"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POPCORN_SIGMA_MODEL_TYPES = void 0;
exports.POPCORN_SIGMA_MODEL_TYPES = [
    'resistor.standard',
    'resistor.variable',
    'resistor.varistor',
    'resistor.thermistor',
    'capacitor.nonpolarized',
    'capacitor.polarized',
    'capacitor.feedthrough',
    'inductor.standard',
    'ferrite.standard',
    'diode.generic',
    'diode.zener',
    'diode.tvs.bidirectional',
    'diode.tvs.unidirectional',
    'fuse.generic',
    'fuse.poly',
    'jumper.2h',
    'switch.spst',
    'crystal',
    'antenna.chip',
    'battery.generic',
    'connector.test-point',
    'connector.mechanical-contact',
    'ground.standard',
    'supply.standard',
];
//# sourceMappingURL=popcorn-sigma-model-types.js.map